<template>
  <div class="student-layout">
    <!-- 顶部蓝紫色条 -->
    <div class="top-bar">
      <div class="top-bar-content">
        <div class="page-title">{{ currentPageTitle }}</div>
      </div>
    </div>
    
    <!-- 遮罩层，点击空白处关闭侧边栏 -->
    <div v-show="!isCollapse" class="sidebar-mask" @click="toggleSidebar"></div>
    
    <el-container>
      <!-- 侧边栏，添加滑动动画 -->
      <el-aside 
        class="sidebar-container" 
        :class="{'sidebar-open': !isCollapse, 'sidebar-closed': isCollapse}">
        <div class="sidebar-header">
          <div class="logo-wrapper">
            <div class="logo">托管</div>
          </div>
          <div class="title-wrapper">
            <div class="school-title">托管中心</div>
            <div class="module-title">学生中心</div>
          </div>
        </div>
        
        <div class="sidebar-nav">
          <div class="nav-group">
            <div class="nav-group-title">学习导航</div>
            <el-menu
              :default-active="activeMenu"
              class="sidebar-menu"
              router
              background-color="#fff"
              text-color="#303133"
              active-text-color="#4f46e5">
              <el-menu-item :index="getPathWithSchool('')">
                <i class="el-icon-s-home"></i>
                <span slot="title">首页</span>
              </el-menu-item>
              <el-menu-item :index="getPathWithSchool('performance')">
                <i class="el-icon-s-claim"></i>
                <span slot="title">表现记录</span>
              </el-menu-item>
              <el-menu-item :index="getPathWithSchool('wrong-questions')">
                <i class="el-icon-notebook-2"></i>
                <span slot="title">错题本</span>
              </el-menu-item>
            </el-menu>
          </div>
        </div>
      </el-aside>
      
      <el-container class="main-container">
        <el-header height="60px" class="header">
          <div class="header-left">
            <i 
              :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'" 
              class="collapse-btn"
              @click="toggleSidebar"></i>
          </div>
          <div class="header-right">
            <el-dropdown trigger="click">
              <div class="avatar-container">
                <el-avatar :size="32" :src="userAvatar || 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'"></el-avatar>
                <span class="name">{{ userName || '学生用户' }}</span>
                <i class="el-icon-caret-bottom"></i>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="openProfileDialog">个人信息</el-dropdown-item>
                <el-dropdown-item @click.native="openPhoneDialog">更新手机号</el-dropdown-item>
                <el-dropdown-item @click.native="openPasswordDialog">修改密码</el-dropdown-item>
                <el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-header>
        
        <el-main class="main-content">
          <router-view />
        </el-main>
        
        <!-- 个人信息对话框 -->
        <el-dialog
          title="个人信息"
          :visible.sync="profileDialogVisible"
          width="90%"
          top="5vh"
          :fullscreen="false"
          custom-class="profile-dialog"
          :class="{'mobile-dialog': isMobile}">
          <div v-loading="profileLoading" class="profile-container">
            <div v-if="profileData" class="user-profile">
              <div class="profile-header">
                <el-avatar :size="80" :src="profileData.avatar || 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'"></el-avatar>
                <div class="user-name">{{ profileData.student_info?.real_name || profileData.username }}</div>
                <div class="user-role">学生</div>
              </div>
              
              <el-divider content-position="left">基本信息</el-divider>
              
              <div class="info-section">
                <div class="info-item">
                  <div class="info-label">用户名</div>
                  <div class="info-value">{{ profileData.username || '无' }}</div>
                </div>
                <div class="info-item">
                  <div class="info-label">手机号</div>
                  <div class="info-value">{{ profileData.phone || '无' }}</div>
                </div>
              </div>
              
              <el-divider content-position="left">学生信息</el-divider>
              
              <div class="info-section">
                <div class="info-item">
                  <div class="info-label">真实姓名</div>
                  <div class="info-value">{{ profileData.student_info?.real_name || '无' }}</div>
                </div>
                <div class="info-item">
                  <div class="info-label">学号</div>
                  <div class="info-value">{{ profileData.student_info?.student_code || '无' }}</div>
                </div>
                <div class="info-item">
                  <div class="info-label">年级</div>
                  <div class="info-value">{{ profileData.student_info?.grade || '无' }}</div>
                </div>
                <div class="info-item">
                  <div class="info-label">年龄</div>
                  <div class="info-value">{{ profileData.student_info?.age ? `${profileData.student_info.age} 岁` : '无' }}</div>
                </div>
                <div class="info-item">
                  <div class="info-label">入学日期</div>
                  <div class="info-value">{{ profileData.student_info?.entry_date || '无' }}</div>
                </div>
                <div class="info-item">
                  <div class="info-label">绑定码</div>
                  <div class="info-value">{{ profileData.student_info?.bind_code || '无' }}</div>
                </div>
                <div class="info-item">
                  <div class="info-label">状态</div>
                  <div class="info-value">{{ profileData.student_info?.status === 1 ? '正常' : '禁用' }}</div>
                </div>
                <div class="info-item">
                  <div class="info-label">备注</div>
                  <div class="info-value">{{ profileData.student_info?.remark || '无' }}</div>
                </div>
              </div>
              
              <el-divider content-position="left">校区信息</el-divider>
              
              <div class="campus-section">
                <div v-if="profileData.campus_info && profileData.campus_info.length > 0">
                  <div v-for="(campus, index) in profileData.campus_info" :key="index" class="campus-card">
                    <div class="campus-header">
                      <div class="campus-name">{{ campus.campus_name }}</div>
                      <el-tag v-if="campus.is_main" size="small" type="success">主校区</el-tag>
                    </div>
                    <div class="campus-body">
                      <div class="campus-info">
                        <i class="el-icon-location"></i>
                        <span>{{ campus.address }}</span>
                      </div>
                      <div class="campus-info">
                        <i class="el-icon-phone"></i>
                        <span>{{ campus.contact_phone }}</span>
                      </div>
                      <div class="campus-stars">
                        <i v-for="n in 5" :key="n" 
                          :class="['el-icon-star-on', {'active': n <= campus.star_level}]"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="empty-campus-info">
                  <i class="el-icon-office-building"></i>
                  <p>暂无校区信息</p>
                </div>
              </div>
            </div>
            <div v-else-if="!profileLoading" class="empty-info">
              <i class="el-icon-warning-outline"></i>
              <p>无法获取个人信息</p>
            </div>
          </div>
        </el-dialog>
        
        <!-- 修改密码对话框 -->
        <el-dialog
          title="修改密码"
          :visible.sync="passwordDialogVisible"
          width="90%"
          top="15vh"
          :fullscreen="false"
          custom-class="password-dialog"
          :class="{'mobile-dialog': isMobile}">
          <el-form 
            ref="passwordForm" 
            :model="passwordForm" 
            :rules="passwordRules" 
            label-width="100px"
            status-icon>
            <el-form-item label="旧密码" prop="old_password">
              <el-input 
                v-model="passwordForm.old_password" 
                type="password" 
                placeholder="请输入旧密码"
                show-password></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="new_password">
              <el-input 
                v-model="passwordForm.new_password" 
                type="password" 
                placeholder="请输入新密码"
                show-password></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="confirm_password">
              <el-input 
                v-model="passwordForm.confirm_password" 
                type="password" 
                placeholder="请再次输入新密码"
                show-password></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" :loading="changingPassword" @click="submitPasswordForm">确认修改</el-button>
              <el-button @click="resetPasswordForm">重置</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
        
        <!-- 更新手机号对话框 -->
        <phone-dialog v-model="phoneDialogVisible" :user-profile="profileData" @phone-updated="handlePhoneUpdated"></phone-dialog>
        
        <el-footer height="40px" class="footer">
          <div class="footer-content">
            <span>© {{ currentYear }} 校园管理系统</span>
          </div>
        </el-footer>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { getUserProfile, changePassword } from '@/api/user';
import PhoneDialog from '@/components/PhoneDialog.vue';

export default {
  name: 'StudentLayout',
  components: {
    PhoneDialog
  },
  data() {
    // 确认密码的验证函数
    const validateConfirmPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.passwordForm.new_password) {
        callback(new Error('两次输入密码不一致'));
      } else {
        callback();
      }
    };
    
    return {
      isMobile: false,
      // 个人信息对话框
      profileDialogVisible: false,
      profileLoading: false,
      profileData: null,
      
      // 修改密码对话框
      passwordDialogVisible: false,
      changingPassword: false,
      passwordForm: {
        old_password: '',
        new_password: '',
        confirm_password: ''
      },
      passwordRules: {
        old_password: [
          { required: true, message: '请输入旧密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能小于6个字符', trigger: 'blur' }
        ],
        new_password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '密码长度不能小于6个字符', trigger: 'blur' }
        ],
        confirm_password: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { validator: validateConfirmPassword, trigger: 'blur' }
        ]
      },
      
      // 更新手机号对话框
      phoneDialogVisible: false,
    };
  },
  computed: {
    ...mapGetters({
      isCollapse: 'isCollapse',
      userName: 'auth/userName',
      userAvatar: 'auth/userAvatar'
    }),
    activeMenu() {
      return this.$route.path;
    },
    currentYear() {
      return new Date().getFullYear();
    },
    schoolCode() {
      return this.$route.params.schoolCode || localStorage.getItem('schoolCode') || 'SCH0001';
    },
    campusCode() {
      return this.$route.params.campusCode || (localStorage.getItem('currentCampus') ? JSON.parse(localStorage.getItem('currentCampus')).code : '') || '';
    },
    currentPageTitle() {
      // 根据当前路由路径返回页面标题
      const path = this.$route.path;
      if (path.includes('/performance')) {
        return '表现记录';
      } else if (path.includes('/wrong-questions')) {
        return '错题本';
      }
      return '学生主页';
    }
  },
  methods: {
    ...mapActions(['toggleSidebar']),
    // 打开个人信息对话框
    openProfileDialog() {
      this.profileDialogVisible = true;
      this.fetchUserProfile();
    },
    
    // 获取用户个人信息
    fetchUserProfile() {
      this.profileLoading = true;
      getUserProfile()
        .then(response => {
          if (response && typeof response === 'object') {
            this.profileData = response;
            console.log('个人信息获取成功:', response);
          } else {
            this.$message.error('获取个人信息失败：返回数据格式不正确');
          }
        })
        .catch(error => {
          console.error('获取个人信息出错:', error);
          this.$message.error('网络错误，请稍后重试');
        })
        .finally(() => {
          this.profileLoading = false;
        });
    },
    
    // 获取性别显示文本
    getGenderText(gender) {
      const genderMap = {
        0: '未知',
        1: '男',
        2: '女'
      };
      return genderMap[gender] || '未知';
    },
    
    // 打开修改密码对话框
    openPasswordDialog() {
      this.passwordDialogVisible = true;
      this.resetPasswordForm();
    },
    
    // 提交修改密码表单
    submitPasswordForm() {
      this.$refs.passwordForm.validate(valid => {
        if (valid) {
          this.changingPassword = true;
          
          // 调用修改密码API
          changePassword({
            old_password: this.passwordForm.old_password,
            new_password: this.passwordForm.new_password
          })
            .then(response => {
              // API响应已在request.js中处理，这里直接表示成功
              this.$message.success('密码修改成功，请重新登录');
              this.passwordDialogVisible = false;
              // 修改密码成功后，退出登录
              setTimeout(() => {
                this.logoutWithRedirect();
              }, 1500);
            })
            .catch(error => {
              console.error('修改密码出错:', error);
              
              // 尝试从错误对象中获取错误信息
              let errorMsg = '修改密码失败，请稍后重试';
              
              // 检查错误响应中是否包含服务器返回的消息
              if (error.response && error.response.data) {
                const responseData = error.response.data;
                if (responseData.msg) {
                  errorMsg = responseData.msg;
                }
              }
              
              this.$message.error(errorMsg);
            })
            .finally(() => {
              this.changingPassword = false;
            });
        }
      });
    },
    
    // 重置修改密码表单
    resetPasswordForm() {
      if (this.$refs.passwordForm) {
        this.$refs.passwordForm.resetFields();
      }
      this.passwordForm = {
        old_password: '',
        new_password: '',
        confirm_password: ''
      };
    },
    
    // 带重定向的登出方法
    logoutWithRedirect() {
      // 获取当前学校代码
      const schoolCode = this.schoolCode;
      
      this.$store.dispatch('auth/logout').then(() => {
        if (schoolCode) {
          this.$router.push(`/${schoolCode}/login`);
        } else {
          this.$router.push('/login');
        }
      });
    },
    
    // 登出方法
    logout() {
      this.logoutWithRedirect();
    },
    
    getPathWithSchool(path) {
      // 使用校区编码构建路径
      const campusCode = this.campusCode;
      const schoolCode = this.schoolCode;
      
      if (campusCode) {
        // 如果有校区编码，则构建包含校区的路径 /:schoolCode/:campusCode/student/...
        const prefix = `/${schoolCode}/${campusCode}/student`;
        return path ? `${prefix}/${path}` : prefix;
      } else {
        // 向后兼容，如果没有校区编码
        const prefix = `/${schoolCode}/student`;
        return path ? `${prefix}/${path}` : prefix;
      }
    },
    checkScreenSize() {
      this.isMobile = window.innerWidth < 768;
      // 根据屏幕大小设置侧边栏状态
      if (this.isMobile && !this.isCollapse) {
        this.$store.dispatch('toggleSidebar', true);
      } else if (!this.isMobile && this.isCollapse) {
        this.$store.dispatch('toggleSidebar', false);
      }
    },
    
    // 打开手机号更新对话框
    openPhoneDialog() {
      // 确保已获取用户资料
      if (!this.profileData) {
        this.profileLoading = true;
        getUserProfile()
          .then(response => {
            if (response && typeof response === 'object') {
              this.profileData = response;
              console.log('个人信息获取成功:', response);
              this.phoneDialogVisible = true;
            } else {
              this.$message.error('获取个人信息失败：返回数据格式不正确');
            }
          })
          .catch(error => {
            console.error('获取个人信息出错:', error);
            this.$message.error('网络错误，请稍后重试');
          })
          .finally(() => {
            this.profileLoading = false;
          });
      } else {
        this.phoneDialogVisible = true;
      }
    },
    
    // 处理手机号更新成功
    handlePhoneUpdated(newPhone) {
      // 更新用户资料中的手机号
      if (this.profileData) {
        this.profileData.phone = newPhone;
      }
      this.$message.success('手机号已更新为：' + newPhone);
      
      // 手机号更新成功后，延迟1.5秒自动登出
      setTimeout(() => {
        this.$message.info('手机号已更新，请重新登录');
        this.logout();
      }, 1500);
    },
  },
  mounted() {
    console.log('学生布局已加载，路径:', this.$route.path);
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  watch: {
    // 监听路由变化，在移动端下自动隐藏侧边栏
    '$route'() {
      if (this.isMobile && !this.isCollapse) {
        this.$store.dispatch('toggleSidebar', true);
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.student-layout {
  min-height: 100vh;
  
  /* 顶部蓝紫色条 */
  .top-bar {
    height: 40px;
    width: 100%;
    background-color: #4f46e5;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1002;
    color: #fff;
    
    .top-bar-content {
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 20px;
      height: 100%;
      display: flex;
      align-items: center;
      
      .page-title {
        font-size: 16px;
        font-weight: 500;
      }
    }
  }
  
  /* 遮罩层 */
  .sidebar-mask {
    position: fixed;
    top: 40px; /* 从顶部栏下方开始 */
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 1000;
  }
  
  /* 侧边栏 */
  .sidebar-container {
    width: 250px !important;
    height: calc(100vh - 40px); /* 减去顶部栏高度 */
    background-color: #fff;
    overflow: hidden;
    position: fixed;
    z-index: 1001;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;
    top: 40px; /* 从顶部栏下方开始 */
    
    /* 侧边栏动画 */
    &.sidebar-closed {
      transform: translateX(-100%);
    }
    
    &.sidebar-open {
      transform: translateX(0);
    }
    
    /* 顶部标题 */
    .sidebar-header {
      padding: 20px 15px;
      text-align: left;
      border-bottom: 1px solid #eee;
      display: flex;
      align-items: center;
      
      .logo-wrapper {
        margin-right: 15px;
        
        .logo {
          width: 40px;
          height: 40px;
          background-color: #4f46e5;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          font-weight: bold;
          font-size: 14px;
        }
      }
      
      .title-wrapper {
        flex: 1;
        
        .school-title {
          font-size: 18px;
          font-weight: bold;
          color: #303133;
          margin-bottom: 6px;
        }
        
        .module-title {
          font-size: 14px;
          color: #909399;
        }
      }
    }
    
    /* 导航分组 */
    .sidebar-nav {
      padding: 10px 0;
      
      .nav-group {
        margin-bottom: 20px;
        
        .nav-group-title {
          padding: 10px 15px;
          font-size: 14px;
          color: #606266;
          font-weight: 500;
        }
      }
    }
    
    /* 菜单样式 */
    .sidebar-menu {
      border-right: none;
      
      .el-menu-item {
        &.is-active {
          background-color: #f0f0ff;
          color: #4f46e5;
          
          &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            width: 3px;
            background-color: #4f46e5;
          }
        }
        
        &:hover {
          background-color: #f5f7fa;
        }
      }
    }
  }
  
  /* 主内容区 */
  .main-container {
    height: 100vh;
    overflow: hidden;
    margin-left: 0;
    width: 100%;
    
    /* 调整顶部导航栏，为顶部蓝条预留空间 */
    .header {
      background-color: #fff;
      box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: fixed;
      width: 100%;
      z-index: 999;
      top: 40px; /* 为顶部蓝条预留空间 */
      
      .header-left {
        display: flex;
        align-items: center;
        
        .collapse-btn {
          padding: 0 15px;
          font-size: 20px;
          cursor: pointer;
          color: #606266;
          
          &:hover {
            color: #4f46e5;
          }
        }
      }
      
      .header-right {
        margin-right: 20px;
        
        .avatar-container {
          display: flex;
          align-items: center;
          cursor: pointer;
          
          .name {
            margin: 0 5px;
            color: #606266;
          }
        }
      }
    }
    
    /* 调整主内容区，为顶部蓝条和头部导航预留空间 */
    .main-content {
      height: calc(100vh - 100px);
      padding: 20px;
      margin-top: 100px; /* 60px + 40px(蓝条高度) */
      overflow-y: auto;
      background-color: #f5f7fa;
    }
    
    .footer {
      background-color: #fff;
      line-height: 40px;
      text-align: center;
      color: #606266;
      border-top: 1px solid #e6e6e6;
    }
  }
}

/* 个人信息对话框样式 */
.profile-dialog {
  .profile-container {
    padding: 0 10px;
    max-height: 60vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    
    .profile-header {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 20px 0;
      
      .user-name {
        margin-top: 15px;
        font-size: 18px;
        font-weight: bold;
      }
      
      .user-role {
        margin-top: 5px;
        color: #909399;
      }
    }
    
    .info-section {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
      gap: 15px;
      margin-bottom: 20px;
      
      .info-item {
        display: flex;
        
        .info-label {
          width: 80px;
          color: #909399;
          font-size: 14px;
        }
        
        .info-value {
          flex: 1;
          font-size: 14px;
          word-break: break-all;
        }
      }
    }
    
    .campus-section {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
      gap: 20px;
      
      .campus-card {
        border: 1px solid #EBEEF5;
        border-radius: 4px;
        padding: 15px;
        transition: all 0.3s;
        
        &:hover {
          box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        }
        
        .campus-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
          
          .campus-name {
            font-weight: bold;
            font-size: 16px;
          }
        }
        
        .campus-body {
          .campus-info {
            margin-bottom: 8px;
            color: #606266;
            font-size: 14px;
            
            i {
              margin-right: 5px;
              color: #909399;
            }
          }
          
          .campus-stars {
            margin-top: 10px;
            
            i {
              color: #C0C4CC;
              margin-right: 2px;
              
              &.active {
                color: #F7BA2A;
              }
            }
          }
        }
      }
    }
    
    .empty-info {
      text-align: center;
      padding: 40px 0;
      color: #909399;
      
      i {
        font-size: 50px;
        margin-bottom: 20px;
      }
    }
    
    .empty-campus-info {
      text-align: center;
      padding: 20px 0;
      color: #909399;
      
      i {
        font-size: 40px;
        margin-bottom: 10px;
      }
      
      p {
        margin: 0;
      }
    }
  }
}

/* 修改密码对话框样式 */
.password-dialog {
  .el-form {
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
  }
}

/* 移动端对话框样式 */
.mobile-dialog {
  width: 95% !important;
  max-width: 500px !important;
  margin: 0 auto !important;
  border-radius: 8px;
}

:deep(.el-dialog__header) {
  padding: 15px;
}

:deep(.el-dialog__body) {
  padding: 0;
}

:deep(.el-dialog__footer) {
  padding: 10px 15px;
}

@media screen and (max-width: 768px) {
  .main-container {
    .header {
      width: 100% !important;
    }
  }
  
  /* 移动端样式适配 */
  .profile-dialog {
    .profile-container {
      .info-section {
        grid-template-columns: 1fr;
      }
      
      .campus-section {
        grid-template-columns: 1fr;
      }
    }
  }
  
  .password-dialog {
    .el-form {
      width: 100%;
    }
  }
}
</style> 